import "styles/storefront/all.scss"
import "custom-event-polyfill"
import { trimInputs, validateInputs } from "lib/address-validation"
import Vue from "vue/dist/vue.esm"
import VueMq from "vue-mq"
import axios from "axios"
import buildProductCartFormApp from "apps/product-cart-form"
import buildFragranceFinderApp from "apps/fragrance-finder"
import buildTopSellingFragrancesByStateApp from "apps/top-selling-fragrances-by-state"
import buildWickGuideApp from "apps/wick-guide"
import buildReturnableOrders from "apps/returnable-orders"
import buildReimbursementRequests from "apps/reimbursement-requests"
import buildReimbursementRequestFormApp from "apps/reimbursement-request-form"
import buildReimbursementRequest from "apps/reimbursement-request"
import buildQuickOrderApp from "apps/quick-order"
import buildProjectApp from "apps/project"
import buildDedicatedSearch from "apps/dedicated-search"
import TopNav from "components/storefront/top-nav.vue"
import FlashMessage from "components/storefront/flash-message.vue"
import registerClosableDirective from "directives/closable"
import LoginForm from "components/storefront/login-form"
import CartForm from "components/storefront/cart-form"
import ShippingQuoteForm from "components/storefront/shipping-quote-form"
import buildUserPasswordForm from "apps/user-password-form"

import Bugsnag from "@bugsnag/js"
import BugsnagPluginVue from "@bugsnag/plugin-vue"

if (window.csConf.bugsnagAPIKey) {
  Bugsnag.start({
    apiKey: window.csConf.bugsnagAPIKey,
    plugins: [new BugsnagPluginVue(Vue)],
    metadata: {
      order: {
        number: window.csConf.orderNnumber,
      },
      user: {
        id: window.csConf.userId,
      },
    },
  })
}

Vue.use(VueMq, {
  breakpoints: {
    xs: 480,
    sm: 768,
    md: Infinity,
  },
})

// Throws error if Promise polyfill is not available.
// Currently we rely on that algoliasearch loads this,
// but they will stop doing this in v4
require.resolveWeak("es6-promise/auto")

// Adds support for Object.assign to Internet Explorer.
// This automatically polyfills any calls to Object.assign.
require("es6-object-assign/auto")

document.addEventListener("DOMContentLoaded", () => {
  // add custom directives
  registerClosableDirective()

  const csrfToken = document.querySelector('meta[name="csrf-token"]')
  if (csrfToken && csrfToken.getAttribute("content")) {
    axios.defaults.headers.common["X-CSRF-Token"] = csrfToken.getAttribute(
      "content"
    )
  }

  const productCartForm = document.querySelector("#js-cart-form")
  const trimmableInputs = Array.from(
    document.querySelectorAll("form input.trim")
  )
  const validatableInputs = Array.from(
    document.querySelectorAll("form input.validate")
  )
  const fragranceFinder = document.querySelector(".fragrance-finder")
  const topSellingFragrancesByState = document.querySelector(
    ".top-fos-by-state"
  )
  const wickGuide = document.querySelector(".interactive-wick-guide")
  const newReimbursementRequestForm = document.querySelector(
    ".new-reimbursement-request-form"
  )
  const returnableOrdersEl = document.querySelector(".returnable-orders-app");
  const reimbursementRequestsEl = document.querySelector(".reimbursement-requests-app");
  const reimbursementRequestEl = document.querySelector(".show-reimbursement-request");
  const quickOrder = document.querySelector(".quick-order-contents")
  const projects = Array.from(document.querySelectorAll(".project-app"))
  const shoppingCart = document.querySelector("#shopping-cart")
  const dedicatedSearchEl = document.querySelector("#dedicated-search-app")
  const loginForm = document.querySelector("#login-form")
  const userPasswordForm = document.querySelector("#user-password-form")

  // Vue app for the top nav components in the header
  new Vue({
    el: "#header",
    components: {
      TopNav,
    },
  })

  new Vue({
    el: "#flash-messages",
    components: {
      FlashMessage,
    },
  })

  // Vue wrapper for the add to cart button on product pages
  if (productCartForm) {
    buildProductCartFormApp(productCartForm)
  }

  trimInputs(trimmableInputs)
  validateInputs(
    validatableInputs,
    "#checkout_form_address, #quote_shipping_form"
  )

  if (fragranceFinder) {
    buildFragranceFinderApp(fragranceFinder)
  }

  if (topSellingFragrancesByState) {
    buildTopSellingFragrancesByStateApp(
      topSellingFragrancesByState,
      window.csStateFragranceData
    )
  }

  if (wickGuide) {
    buildWickGuideApp(wickGuide)
  }

  if (returnableOrdersEl) {
    buildReturnableOrders(returnableOrdersEl);
  }

  if (reimbursementRequestsEl) {
    buildReimbursementRequests(reimbursementRequestsEl);
  }

  if (newReimbursementRequestForm) {
    buildReimbursementRequestFormApp(newReimbursementRequestForm)
  }

  if (reimbursementRequestEl) {
    buildReimbursementRequest(reimbursementRequestEl);
  }

  if (quickOrder) {
    buildQuickOrderApp(quickOrder)
  }

  if (projects.length > 0) {
    projects.forEach((project) => {
      buildProjectApp(project)
    })
  }

  if (shoppingCart) {
    new Vue({
      el: shoppingCart,
      components: {
        CartForm,
        ShippingQuoteForm,
      },
      methods: {
        updateShippingQuote() {
          this.$refs["shipping-quote-form"].update()
        },
      },
    })
  }

  if (dedicatedSearchEl) {
    buildDedicatedSearch(dedicatedSearchEl)
  }

  if (loginForm) {
    new Vue({
      el: loginForm,
      components: {
        LoginForm,
      },
    })
  }

  if (userPasswordForm) {
    buildUserPasswordForm(userPasswordForm)
  }
})
